module.exports = __webpack_public_path__ + "static/16-top-10-soft-skills-you-need-to-succeed-b3ff7d1693c24ded4ed097786217e1cb.jpg";